import React, { Component } from "react";
import { classNames } from "react-extras";
class GraphContainer extends Component {
  render() {
    return (
      <div className="stats-widget-graph-container">
        <div className={classNames("stats-widget-graph-title", this.props.titleClassName)}>
          <h3>{this.props.title}</h3>
        </div>
        <div className="stats-widget-graph">{this.props.children}</div>
      </div>
    );
  }
}

export default GraphContainer;
